import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { orgSearch, orgSelect } from './login_halper';
import { Autocomplete, Backdrop, CircularProgress } from '@mui/material';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: { maxWidth: '450px' },
  boxShadow: 'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow: 'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
  minHeight: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage: 'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage: 'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

export default function EnterpriseSelect(props) {
  const [enterpriseError, setEnterpriseError] = useState(false);
  const [enterpriseErrorMessage, setEnterpriseMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const navigate = useNavigate();

  const searchOrg = (event) => {
    if (event.target.value.length >= 3) {
      orgSearch(event.target.value).then((res) => {
        if (res !== false) {
          setOrgList(res);
        }
      }).catch((err) => {
        console.log(err);
      })
    } else {
      setOrgList([]);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (enterpriseError) {
      return;
    }
    setLoading(true);
    const data = new FormData(event.currentTarget);
    const ep_name = data.get("enterprise");
    let ep_id = "";
    orgList.forEach((itm) => {
      if (itm.name === ep_name) {
        ep_id = itm.office_id
        return;
      }
    });
    if (ep_id === "") {
      setLoading(false);
      return;
    }
    orgSelect(ep_id).then((res) => {
      if (res === true) {
        navigate("/")
      } else if (res !== false) {
        console.log(res);
        setEnterpriseError(true);
        setEnterpriseMessage(res.message);
      }
      setLoading(false);
    }).catch((err) => {

    });

  };

  const validateInputs = () => {
    const enterprise = document.getElementById('enterprise');

    let isValid = true;

    if (!enterprise.value) {
      setEnterpriseError(true);
      setEnterpriseMessage('Write five(5) charecter to get suggestion.');
      isValid = false;
    } else {
      setEnterpriseError(false);
      setEnterpriseMessage('');
    }

    return isValid;
  };

  return (
    <div {...props}>
      <CssBaseline enableColorScheme />
      <SignInContainer direction="column" sx={{ justifyContent: "space-between", backgroundColor: "primary.background" }}>
        <Card variant="outlined">
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
          >
            Enterprise Select
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            <FormControl>
              {/* <FormLabel htmlFor="enterprise">Enterprise</FormLabel> */}
              <Autocomplete
                id="enterprise"
                disablePortal
                options={orgList}
                onKeyUp={searchOrg}
                getOptionLabel={option => option.name}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return <Box key={key}
                    component="li"
                    {...optionProps}>
                    {option.name}
                  </Box>
                }}
                renderInput={(params) =>
                  <TextField
                    name="enterprise"
                    autoComplete="enterprise"
                    error={enterpriseError}
                    helperText={enterpriseErrorMessage} {...params}
                    label="Enterprise Name"
                    autoFocus
                    fullWidth
                    variant="outlined"
                    color={enterpriseError ? 'error' : 'primary'}
                    placeholder="Enterprise Name"
                  />}
              />

            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={validateInputs}
            >
              Next
            </Button>
            <Backdrop
              sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
          <Divider>or</Divider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => alert('Change Enterprise not allowed')}
            >
              Enterprise Help
            </Button>
            <Typography sx={{ textAlign: 'center' }}>
              Don&apos;t have an account?{' '}
              <Link
                href="/sign-in"
                variant="body2"
                sx={{ alignSelf: 'center' }}
              >
                Sign up
              </Link>
            </Typography>
          </Box>
        </Card>
      </SignInContainer>
    </div>
  );
}
